<template>
  <div class="upload-box">
    <a-card :bordered="false">
      <div class="shopinfo-content">
        <a-button class="editable-add-btn" type="danger" @click="haoEmpty"
          >清空号码</a-button
        >
      </div>
      <div class="line">
        <a-upload
          :file-list="fileList"
          :remove="handleRemove"
          :before-upload="beforeUpload"
          accept=".txt"
          class="uplaod-input"
        >
          <a-button> <a-icon type="upload" />选择文件</a-button>
        </a-upload>
        <a-button
          class="upload-btn"
          type="primary"
          :disabled="fileList.length === 0"
          :loading="uploading"
          style="margin-top: 16px"
          @click="handleUpload"
        >
          {{ uploading ? "上传中" : "开始上传" }}
        </a-button>
      </div>
      <div class="line">上传记录</div>
      <a-table
        :columns="columnsUpload"
        :dataSource="uploadList"
        :pagination="false"
        :rowKey="menuList => menuList.id"
        size="small"
      >
        <div slot="timer" slot-scope="record">
          <span v-timer="record.created_time"></span>
        </div>
        <div slot="status" slot-scope="record">
          <span>{{ record === "-1" ? "异常" : "更新完成" }}</span>
        </div>
      </a-table>
      <!-- 详情提示 -->
      <a-modal
        title="提示"
        :visible="visibleEmpty"
        @ok="moreEmptySure"
        okType="danger"
        okText="删除"
        cancelText="取消"
        :confirmLoading="confirmLoading"
        @cancel="downMoreCancel"
      >
        <p>{{ emptyTips }}</p>
      </a-modal>
      <!-- 详情提示 -->
    </a-card>
  </div>
</template>

<script>
import { SETTING_query, SETTING_update } from "@/api/setting";
import { HAO_manage_empty, HAO_upload_list } from "@/api/hao";
import Api from "@/api/api";
import axios from "axios";
import "@/utils/directive";
const columnsUpload = [
  {
    title: "ID",
    dataIndex: "id"
  },
  {
    title: "文件名",
    dataIndex: "file_name"
  },
  {
    title: "上传总数",
    dataIndex: "total"
  },
  {
    title: "状态",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
    align: "center"
  },
  {
    title: "上传时间",
    key: "created_time",
    scopedSlots: { customRender: "timer" },
    align: "center"
  }
];
export default {
  data() {
    return {
      columnsUpload,
      uploadList: [],
      siteInfo: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      form: {
        title: "",
        subtitle: "",
        keywords: "",
        description: "",
        icp: "",
        url: "",
        baidu: ""
      },
      fileList: [],
      uploading: false,
      visibleEmpty: false,
      emptyTips: "确认清空当前网站的所有号码吗",
      confirmLoading: false
    };
  },
  created() {},
  mounted() {
    this.getInfo({ type: "seo" });
    this.getUploadList();
  },
  methods: {
    getUploadList: function() {
      HAO_upload_list()
        .then(response => {
          this.uploadList = response.res;
        })
        .catch(() => {});
    },
    getInfo: function(_obj) {
      SETTING_query(_obj)
        .then(response => {
          this.form = response.res;
        })
        .catch(() => {});
    },
    setInfo: function(_obj) {
      SETTING_update({
        type: "seo",
        info: _obj
      })
        .then(response => {
          console.log(response.res);
          if (response.status === 0) {
            this.$notification.success({
              message: "提示",
              description: response.res
            });
          } else {
            this.$notification.success({
              message: "提示",
              description: response.res
            });
          }
        })
        .catch(() => {});
    },
    haoEmpty: function() {
      this.visibleEmpty = true;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      this.fileList = [file];
      return false;
    },
    handleUpload() {
      //上传
      const { fileList } = this;
      const formData = new FormData();
      formData.append("file", fileList[0]);
      axios
        .post(Api.hao_manage_upload, formData)
        .then(response => {
          let _response = response.data;
          if (_response.status === 0) {
            this.$notification.success({
              message: "提示",
              description: _response.res
            });
          } else {
            this.$notification.success({
              message: "提示",
              description: _response.res
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    moreEmptySure: function() {
      HAO_manage_empty()
        .then(response => {
          console.log(response.res);
          if (response.status === 0) {
            this.visibleEmpty = false;
            this.$notification.success({
              message: "提示",
              description: response.res
            });
          } else {
            this.$notification.success({
              message: "提示",
              description: response.res
            });
          }
        })
        .catch(() => {});
    },
    downMoreCancel: function() {
      this.visibleEmpty = false;
    }
  }
};
</script>

<style lang="less" scoped>
.shopinfo-content {
  .btn-list {
    margin-top: 30px;
  }
}
.upload-box {
  .line {
    font-size: 20px;
    margin-top: 20px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    .uplaod-input {
      width: 80%;
      display: flex;
      .ant-upload-list-item-info {
        padding: 0 22px !important;
      }
    }
    .upload-btn {
      margin-top: 0px !important;
    }
  }
  .ant-upload-list {
    display: inline-block;
  }
}
</style>
